/** Queued detection from email onboarding (`queueTripDetection` lookback). */
export const EMAIL_SYNC_ONBOARDING_LOOKBACK_DAYS = 90;

/**
 * User-facing copy for inbox trip detection: explains we filter by message arrival date.
 */
export function emailScanLookbackExplanation(days: number): string {
  return `We search messages from the last ${days} days based on when they arrived; older confirmations may need to be entered manually or through our smart upload feature in the trip's itinerary.`;
}

/** What the *current completed or in-progress* scan window means (single source of truth for the banner). */
export function emailScanArrivalWindowForScan(days: number): string {
  return `This scan includes messages that arrived in your inbox in the last ${days} days.`;
}

export function emailOlderConfirmationsHint(): string {
  return `Older confirmations may need to be entered manually or added with Smart Upload from that trip's itinerary.`;
}

/** Shown on the “deeper scan” card so we don’t repeat the same paragraph with a different day count. */
export function emailScanDeeperScanTeaser(fullDays: number, quickDays: number): string {
  return `Your first pass covered the last ${quickDays} days. Scan up to ${fullDays} days to catch older booking emails (still by when each message arrived).`;
}
